export const MODULE = 'MISCELLANEOUS_FEES';

// misc fee
export const GET_MISC_FEE_SETTINGS_FEES_LIST = `${MODULE}/get_misc_fee_settings_fees_list`;
export const SHOW_MISC_FEE_SETTINGS_FEES = `${MODULE}/show_misc_fee_settings_fees`;

export const CREATE_MISC_FEE_SETTINGS_FEES = `${MODULE}/ADD_misc_fee_settings_fees`;
export const UPDATE_MISC_FEE_SETTINGS_FEES = `${MODULE}/update_misc_fee_settings_fees`;
export const REMOVE_MISC_FEE_SETTINGS_FEES = `${MODULE}/remove_misc_fee_settings_fees`;

// office
export const GET_MISC_FEE_SETTINGS_OFFICES_LIST = `${MODULE}/get_mist_fee_settings_offices_list`;
export const SHOW_MISC_FEE_SETTINGS_OFFICE = `${MODULE}/show_misc_fee_settings_office`;

export const CREATE_MISC_FEE_SETTINGS_OFFICE = `${MODULE}/ADD_misc_fee_settings_office`;
export const UPDATE_MISC_FEE_SETTINGS_OFFICE = `${MODULE}/update_misc_fee_settings_office`;
export const REMOVE_MISC_FEE_SETTINGS_OFFICE = `${MODULE}/remove_misc_fee_settings_office`;

// others
export const GET_ROLE_LIST = 'ROLE/get_role_list';


export const FORMS = {
  office_id: '',
  account_code: '',
  account_title: '',
  amount: '',
  ppsas_code: '',
  fund_types: {
    gf: 0,
    tf: 0,
    sef: 0,
  },
}

export const FORMS_OFFICE = {
  name: '',
  code: '',
  description: '',
}

export const IS_ACTIVE = { is_active: 1 }